import { apiCall } from "../../APICall";
import * as t from "io-ts";
import { eq } from "fp-ts";
import { constFalse } from "fp-ts/function";
import { NonEmptyString } from "io-ts-types/lib/NonEmptyString";

export const confirmUpload = apiCall({
  inputCodec: t.void,
  inputEq: eq.fromEquals(constFalse),
  path: ["packages", "loans", "standard-loan", "confirmUpload"],
});

const CheckDisplaySmsLinkOptionOutput = t.type({
  displaySmsLinkOption: t.boolean,
});

const CheckDisplaySmsLinkOptionInput = t.type({
  documentTypeId: NonEmptyString,
});

export const checkDisplaySmsLinkOption = apiCall({
  inputEq: eq.getStructEq({
    documentTypeId: eq.eqString,
  }),
  path: [
    "packages",
    "loans",
    "standard-loan",
    "document",
    "checkDisplaySmsLinkOption",
  ],
  inputCodec: CheckDisplaySmsLinkOptionInput,
  outputCodec: CheckDisplaySmsLinkOptionOutput,
});
